import { Link } from "react-router-dom";

const LAST_UPDATED = "August 29, 2026";

const Privacy = () => {
  return (
    <div className="min-h-screen w-full relative overflow-x-hidden text-white">
      <div
        className="fixed inset-0 z-[-1]"
        style={{
          backgroundImage: `url('/bg-hero.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="relative z-10 max-w-2xl mx-auto px-4 py-12 sm:py-16">
        <div className="backdrop-blur-2xl bg-black/40 border border-white/10 rounded-3xl p-6 sm:p-10 shadow-2xl">
        <h1
          className="text-3xl sm:text-4xl mb-2"
          style={{ fontFamily: "Anton, sans-serif" }}
        >
          <span className="text-[#00F0FF]">PRIVACY</span> POLICY
        </h1>
        <p className="text-[#A1A1AA] text-sm mb-10">Last updated: {LAST_UPDATED}</p>

        <div className="space-y-8 text-[#D4D4D8] leading-relaxed">
          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Overview</h2>
            <p>
              Tap First ("we," "us," "the game") is a real-time buzzer game at tap-first.com. This
              page explains what information we collect when you use it, why, and what your
              options are. Playing as a guest (joining a room without an account) requires no
              personal information beyond the display name you choose to enter.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">What we collect</h2>
            <p className="mb-2">If you create a host account, we collect:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Your name and email address</li>
              <li>A securely hashed version of your password (we never store or see the plain-text password) if you sign up with email/password</li>
              <li>Your name, email, and profile info from Google if you sign in with Google — we don't receive your Google password</li>
              <li>Basic room activity: rooms you create, room settings, and participant names in your rooms</li>
              <li>Payment status (whether you've purchased Pro access) and a transaction reference — actual payment card details are handled entirely by our payment processor, Gumroad; we never see or store your card information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">How we use it</h2>
            <p>
              We use this information to run your account, let you host and manage buzzer game
              rooms, unlock Pro features after purchase, and keep the game secure. We do not sell
              your personal information, and we don't use it for advertising.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Who we share it with</h2>
            <p className="mb-2">We rely on a small number of service providers to run Tap First:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li><span className="text-white">Fly.io</span> — hosts the application</li>
              <li><span className="text-white">MongoDB Atlas</span> — stores account and room data</li>
              <li><span className="text-white">Gumroad</span> — processes payments for Pro access</li>
              <li><span className="text-white">Google</span> — provides optional "Sign in with Google" authentication</li>
            </ul>
            <p className="mt-2">
              Each of these providers only receives what's necessary to perform their function, and
              is bound by its own privacy and security practices.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Cookies</h2>
            <p>
              We use a single essential cookie to keep you signed in (a secure, HTTP-only session
              cookie). We don't use tracking or advertising cookies.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Your choices</h2>
            <p>
              You can request access to, correction of, or deletion of your account data at any
              time by emailing us at{" "}
              <a href="mailto:info@tap-first.com" className="text-[#00F0FF] hover:underline">
                info@tap-first.com
              </a>.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Changes to this policy</h2>
            <p>
              If we make material changes to this policy, we'll update the date at the top of this
              page.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-2">Contact</h2>
            <p>
              Questions about this policy? Email{" "}
              <a href="mailto:info@tap-first.com" className="text-[#00F0FF] hover:underline">
                info@tap-first.com
              </a>.
            </p>
          </section>
        </div>

        <p className="mt-12 text-center">
          <Link to="/" className="text-[#A1A1AA] hover:text-white text-sm">← Back to home</Link>
        </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
